/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, ThemeProvider as ThemeUIProvider, ColorMode } from 'theme-ui';
import { Global, css } from '@emotion/core';
import emotionReset from 'emotion-reset';
import theme from '../../constants/theme';
import fontSources from '../../constants/font-sources';
export function ThemeProvider({ children }) {
    return (jsx(ThemeUIProvider, { theme: theme },
        jsx(ColorMode, null),
        jsx(Global, { styles: t => css `
          ${emotionReset}

          body {
            font-family: ${t.fonts.primary};
            font-size: ${t.fontSizes.xxs}px;
            font-weight: ${t.fontWeights.normal};
            color: ${t.colors.darkLineBorder};
          }

          strong {
            font-weight: bold;
          }

          em {
            font-style: italic;
          }

          ul {
            list-style-type: disc;
            margin-left: 20px;
            li {
              font-size: inherit;
            }
          }

          @font-face {
            font-family: 'EuclidCircularB';
            src: url(${fontSources.euclidCircularBRegular});
            font-weight: 400;
            font-style: normal;
            font-display: swap;
            -webkit-font-smoothing: antialiased;
          }

          @font-face {
            font-family: 'EuclidCircularB';
            src: url(${fontSources.euclidCircularBMedium});
            font-weight: 600;
            font-style: normal;
            font-display: swap;
            -webkit-font-smoothing: antialiased;
          }

          @font-face {
            font-family: 'Baskerville';
            src: url(${fontSources.baskerville});
            font-weight: 300;
            font-style: normal;
            font-display: swap;
            -webkit-font-smoothing: antialiased;
          }
        ` }),
        children));
}
//# sourceMappingURL=theme-provider.js.map